<template>
  <tbody>
    <template v-for="(cenario, indexc) in cenarios">
      <!-- <template v-if="indexc > 0">
        <tr :key="indexc">
          <th
          style="z-index: 3 !important"
          class="bordazIndex text-left pb-0"></th>
          <b-th
            class="pb-0"
            :colspan="parsePlanos(operadora.grupos).length"
            v-for="(operadora, indexo) in cenario.operadoras"
            :key="`logo-grupo-${indexc}-${indexo}`">
            <b-img
              center
              :src="operadora.logotipoavo"
              style="width: 80px"
              :alt="operadora.nome"
              :title="operadora.nome"
            />
            <div
              class="cor-logo"
              :style="`
                height: 3px;
                background-color: ${operadora.cor ? '#'+operadora.cor : 'grey'};
                margin: 0 auto;
                border-radius: 25px;
              `"
            ></div>
          </b-th>
        </tr>
      </template> -->
      <tr class="alternate totalizadorTable" :key="`grupo-${indexc}`">
        <th class="bordazIndex text-left"
            style="height: 100% !important; z-index: 3 !important">
          <div class="resGeralAling">
            <span>
              <strong class="text-info p-3"> {{ cenario.nome }}</strong>
            </span>
            <span
              class="text-right pr-4">
              {{ totalVidas(cenario) }}
            </span>
          </div>
        </th>
        <template v-for="(operadora, indexo) in cenario.operadoras">
          <b-td
            class="alinharValores"
            :class="{ 'text-center': indexp == 0 }"
            v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
            :key="`total-${indexc}-${indexo}-${plano.id}-${indexp}`">
            {{ calcularTotal(plano) | valor }}
            <b 
              v-if="plano.calculo.taxa_descricao"
              variant="link"
              class="shadow-none"
              v-b-popover.hover="{content:plano.calculo.taxa_descricao, html:true, customClass: 'taxa_descricao'}"
            >*</b>
          </b-td>
        </template>
      </tr>
    </template>
  </tbody>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters("cenario", {
      cenarios: "getCenarios"
    }),
  },
  methods: {
    totalVidas(cenario) {
      let vidas = 0
      return vidas += cenario.faixas
        .map(f => Number(f.value))
        .reduce((o, c) => parseInt(o) + parseInt(c))
    },
    calcularTotal(plano) {
      return plano.filtros.regras_aceitacao && (plano.alertas && plano.alertas.length > 0)
        ? 0
        : plano.taxas.iof == true ? plano.calculo.total_iof : plano.calculo.total
    },
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, [])
    }
  }
}
</script>

<style>

</style>
